var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatsGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 138,
    viewBox: "0 0 503 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.801 57.5619C23.8839 57.5619 2 72.5504 2 72.5504V138H502V22.5888C502 22.5888 480.954 31.744 471.388 28.5843C457.902 24.1301 445.24 2.75412 436.949 2.10453C424.194 1.10517 428.02 7.60042 401.872 7.6004C377 7.60038 388.185 20.5904 363.607 20.5904C350.15 20.5904 330.444 31.5848 330.444 31.5848H291.541C273.046 31.5848 269.276 63.9031 248.811 61.5617C228.976 59.2922 229.679 54.0646 213.735 54.0646C198.14 54.0646 195.738 61.7107 179.934 60.06C160.801 58.0615 161.439 36.5781 135.291 36.5781C103.403 36.5781 97.6633 63.0577 72.1531 65.0561C53.4237 66.5234 56.3698 57.5619 35.801 57.5619Z",
    fill: "url(#paint0_linear_1_441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 73.0002C2 73.0002 23.8839 58.0002 35.801 58.0002C56.3698 58.0002 53.4237 66.9685 72.1531 65.5002C97.6633 63.5002 103.403 37.0002 135.291 37.0002C161.439 37.0002 160.801 58.5002 179.934 60.5002C195.738 62.1522 198.14 54.5002 213.735 54.5002C229.679 54.5002 228.976 59.7318 248.811 62.003C269.276 64.3462 273.046 32.003 291.541 32.003C307.139 32.003 330.444 32.003 330.444 32.003C330.444 32.003 350.15 21.0002 363.607 21.0002C388.185 21.0002 377 8.00015 401.872 8.00017C428.02 8.00019 424.194 1.49994 436.949 2.50008C445.24 3.15016 457.902 24.5426 471.388 29.0002C480.954 32.1624 502 23.0002 502 23.0002",
    stroke: "#6EDCB5",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_441",
    x1: 252,
    y1: 2,
    x2: 252,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDCB5",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EDCB5",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsGraph);
export default __webpack_public_path__ + "static/media/stats-graph.56f66d97604aeee70c6df864fac5cd39.svg";
export { ForwardRef as ReactComponent };